















































































import {
  defineComponent,
  watch,
  computed,
  reactive
} from "@vue/composition-api";
import { getJobEvents } from "@/api";
import { useRequest } from "@/helpers/hooks/useRequest";
import ListTable, { Props } from "@/components/Molecules/ListTable/index.vue";
import Heading from "@/components/Atoms/Typography/Heading/index.vue";
import OccHeading from "@/components/Atoms/OccHeading/index.vue";
import dayjs from "dayjs";
import { useRouter } from "@/router";

export default defineComponent({
  name: "JobEvents",
  components: {
    Heading,
    ListTable,
    OccHeading
  },
  setup(_, { emit }) {
    const [{ data: jobEvents, loading: jobEventsLoading }] = useRequest(
      () =>
        getJobEvents({
          title: "",
          public_statuses: ["public"],
          sort: "updated_at",
          order: "desc",
          limit: 4,
          offset: 0
        }),
      {
        immediate: true
      }
    );
    const router = useRouter();

    const headers = reactive<Props["headers"]>([
      {
        name: "アイキャッチ画像",
        minSizeContainer: "176px"
      },
      {
        name: "イベントタイトル",
        subHeaders: [{ name: "識別コード | 最終編集日" }],
        minSizeContainer: "385px"
      },
      {
        name: "卒年",
        minSizeContainer: "114px"
      },
      {
        name: "応募人数",
        minSizeContainer: "114px"
      },
      {
        name: "未抽選人数",
        minSizeContainer: "114px"
      }
    ]);

    const tableRows = computed(() => {
      if (jobEvents.value && jobEvents.value.events) {
        return jobEvents.value.events.map(event => {
          return {
            ...event,
            alert: event.approval_status === "rejected"
          };
        });
      }
      return [];
    });

    watch(jobEventsLoading, newValue => {
      emit("changeJobEventsLoading", newValue);
    });

    const formatFromNow = (date: string) => {
      return dayjs(new Date(date)).fromNow();
    };

    const onClickRow = (rowIndex: number) => {
      const eventId = tableRows.value?.[rowIndex].id;
      if (eventId) {
        router
          .push({
            name: "JobEvent",
            params: { eventId: String(eventId) }
          })
          .catch(err => err);
      }
    };

    const handleClickEventsMore = () => {
      const eventsMoreRoute = router.resolve({
        name: "JobEvents"
      });
      window.open(eventsMoreRoute.href, "_blank", "noopener");
    };

    return {
      jobEvents,
      headers,
      tableRows,
      jobEventsLoading,
      formatFromNow,
      onClickRow,
      handleClickEventsMore
    };
  }
});
